<template>
  <validation-provider
    :vid="id"
    :name="id"
    :rules="validations"
    v-slot="{ errors }"
  >
    <v-text-field
      :label="label"
      :error-messages="errors"
      :placeholder="placeholder"
      :disabled="disabled"
      :clearable="clearable"
      :autocomplete="false"
      v-model="inputValue"
      v-currency="{
        currency: null,
        locale: 'en',
        allowNegative: false,
        valueRange: { min: 0 },
      }"
      @blur="blur"
    />
  </validation-provider>
</template>

<script>
import { CurrencyDirective } from 'vue-currency-input'
import InputMixin from './InputMixin'

export default {
  mixins: [InputMixin],
  directives: {
    currency: CurrencyDirective,
  },
}
</script>
